<template>
  <b-col cols="12" id="letter-management">
    <b-overlay :show="processing" rounded="sm">
      <b-tabs>
        <b-tab disabled title="Gestión de tiquetes" />

        <b-tab>
          <template #title>
            Detalle del documento
            <b-img
              size="12"
              :src="
                require('@/assets/modules/permisos-sindicales/icons/navs/eye.svg')
              "
              rounded="0"
              alt="eye"
            />
          </template>
          <template v-if="processing == false">
            <b-container fluid class="avoid-overflow body-color">
              <b-col cols="12">
                <b-img
                  fluid
                  :src="headerTemplate"
                  class="header-img"
                  size="24"
                  alt="header"
                />
              </b-col>
              <p class="pt-5">
                {{ capitalizeText(petitioner.city) }}, {{ getDate }}
              </p>
              <p>
                Sres.
                <br />
                {{ businessPartner.society }}
                <br />
                <em class="title-color">{{
                  capitalizeText(businessPartner.name)
                }}</em>
                <br />
                <em class="title-color">{{ businessPartner.position }}</em>
              </p>
              <p class="mt-4">Ref: Gestión de tiquetes permisos sindicales</p>

              <p class="mt-4">
                Cordial saludo,
                <br />
                Yo/Señor, {{ capitalizeText(template?.name_one) }}
                {{ template?.position_one?.toLowerCase() }}, "{{
                  petitioner?.labor_union
                }}" me dirijo a ustede para informar la gestión de tiquetes del
                siguiente colaborador: {{ capitalizeText(collaborator?.name) }},
                CC {{ collaborator?.cc }}, SHARP ID {{ collaborator?.sharp_id }},
                Salida: {{ collaborator.origin.city_name }}, Destino:
                {{ collaborator.destination.city_name }}. Fecha inicio:
                {{ collaborator.start_date }}, fecha final:
                {{ collaborator.end_date }} por la aerolinea
                {{ management.airline?.name }}. Revisar adjunto con tiquetes.
              </p>

              <p class="mt-5">
                De acuerdo al artículo 57 del código laboral, artículo 38 y 39
                de la constitución política de Colombia, artículos 353, 354,
                405, 467, 468, 475 del CST y el convenio 87 y 98 de la OIT.
              </p>

              <p class="mt-4">
                Agradezco la atención prestada y quedo atento a su pronta
                respuesta.
              </p>

              <p class="mt-3">Cordialmente</p>

              <table class="mt-5">
                <tr>
                  <td align="center">
                    <img
                      width="150"
                      height="50"
                      align="center"
                      :src="backendPath.concat(`/${template.signature_one}`)"
                      alt="signature-presidente"
                    />
                    <hr width="150" />
                    <p>
                      {{ capitalizeText(template.name_one) }}
                      <br />
                      {{ template.position_one }}
                    </p>
                  </td>
                  <td align="center">
                    <img
                      width="150"
                      height="50"
                      align="center"
                      :src="backendPath.concat(`/${template.signature_two}`)"
                      alt="signature-secretario"
                    />
                    <hr width="150" />
                    <p>
                      {{ capitalizeText(template.name_two) }}
                      <br />
                      {{ template.position_two }}
                    </p>
                  </td>
                </tr>
              </table>
            </b-container>
          </template>
        </b-tab>

        <!-- options -->
        <template #tabs-end>
          <li class="nav-item align-self-center ml-2">
            <a :href="downloadPDF" target="_blank"> - Descargar </a>
          </li>
          <li class="nav-item align-self-center ml-2">
            <a :href="dowlandLetterLisence" target="_blank"> - Solicitud </a>
          </li>
          <li class="nav-item align-self-center ml-2">
            <a :href="dowlandLetterAproval" target="_blank"> - Aprobación </a>
          </li>
        </template>
      </b-tabs>
    </b-overlay>
  </b-col>
</template>

<script>
import controller from "./controller";
const { script } = controller();
export default script;
</script>

<style lang="scss" src="./styles.scss" />